import * as Api from "../../libs/api-client";

const actions = {
  async search(_, condition) {
    return Api.commonGet("/user/dashboard", condition);
  },
};

export default {
  namespaced: true,
  state: {},
  getters: {},
  mutations: {},
  actions,
};
